import { ReactNode } from 'react';

/**
 * Pied de page d'un formulaire : aligne les boutons d'action.
 *
 * Exemple :
 *   <FormActions>
 *       <Button variant="text" onClick={onCancel}>Annuler</Button>
 *       <Button type="submit" variant="contained">Enregistrer</Button>
 *   </FormActions>
 */
const FormActions = (props: { children: ReactNode }) => (
    <div className="eb-form-actions">{props.children}</div>
);

export default FormActions;
